import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    ReplenishmentCreate,
    ReplenishmentDto,
    ReplenishmentRead,
    ReplenishmentSearchParams,
} from '../../entities/replenishment.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { ItemMetadataMap } from '@pf/platform-item-catalog/domain';

const symbols = entitySymbols(PFWmsEntities.Replenishment);

withDefaultEntityMetadata<ReplenishmentDto>(symbols.dto, {
    warehouseId: String,
    warehouse: Object,
    item: ItemMetadataMap.symbols.dto,
    itemId: String,
    replenishToSlotId: String,
    replenishToSlot: Object,
    replenishFromSlotId: String,
    replenishFromSlot: Object,
    quantityNeeded: Number,
    quantityReplenished: Number,
    assignedToUserId: String,
    assignedToUser: Object,
    replenishedDate: String,
    inventoryAdjustmentId: String,
    status: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultEntityMetadata<ReplenishmentRead>(symbols.entity, {
    warehouse: Object,
    item: ItemMetadataMap.symbols.entity,
    replenishToSlot: Object,
    replenishFromSlot: Object,
    quantityNeeded: Number,
    assignedToUser: Object,
    replenishedDate: String,
    inventoryAdjustmentId: String,
    status: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    quantityReplenished: Number,
});

withMetadata<ReplenishmentCreate>(symbols.createBody, {
    warehouseId: String,
    itemId: String,
    replenishToSlotId: String,
    replenishFromSlotId: String,
    quantityNeeded: Number,
    assignedToUserId: String,
    status: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    quantityReplenished: Number,
});

withDefaultSearchParamsMetadata<ReplenishmentSearchParams>(
    symbols.searchParams,
    {}
);

export const ReplenishmentMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<ReplenishmentRead, ReplenishmentDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<ReplenishmentDto, ReplenishmentRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<ReplenishmentDto, ReplenishmentCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<ReplenishmentDto>, ReplenishmentSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('warehouseId'),
            withSearchFilter('itemId'),
            withSearchFilter('replenishToSlotId'),
            withSearchFilter('replenishFromSlotId'),
            withSearchFilter('assignedToUserId'),
            withSearchFilter('status'),
            withSearchFilter('priority'),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
